import { useDistanceToTopOfPageMotionValue } from '@/hooks/framer/useDistanceToTopOfPageMotionValue';
import { useMobileTabBarHeightMotionValue } from '@/hooks/framer/useMobileTabBarHeightMotionValue';
import { useViewportHeightMotionValue } from '@/hooks/framer/useViewportHeightMotionValue';
import { useTransform } from 'motion/react';
import { useRef } from 'react';
export function useVideoHeroBlockAnimation(isInEditor) {
    const containerRef = useRef(null);
    const fallbackHeight = isInEditor ? '700px' : '100vh';
    const viewportHeight = useViewportHeightMotionValue();
    const mobileTabBarHeight = useMobileTabBarHeightMotionValue();
    const containerDistanceToTopOfPage = useDistanceToTopOfPageMotionValue(containerRef);
    const containerProperties = {
        minHeight: useTransform(() => viewportHeight.get()
            ? viewportHeight.get() - mobileTabBarHeight.get() - Math.min(200, containerDistanceToTopOfPage.get())
            : fallbackHeight),
        opacity: useTransform(() => (viewportHeight.get() ? 1 : 0)),
    };
    const elementProperties = {
        opacity: useTransform(() => (viewportHeight.get() ? 1 : 0)),
        translate: useTransform(() => (viewportHeight.get() ? '0 0' : '32 0')),
    };
    return {
        containerRef,
        containerProperties,
        elementProperties,
    };
}
